import { Accordion, AccordionItem, Button, Card, Link } from '@nextui-org/react';
import type { UserSort } from '@simppl/repository-admin/common';
import { postUsersLogout } from '@simppl/repository-admin/user';
import { generateStorage } from '@simppl/util/storage';
import { useMemo } from 'react';

import useAdminUserInfo from '../hook/useAdminUserInfo';
import { canAccessByPermissions } from '../utils/permission';
import { MENU_SECTIONS, type MenuSectionDef } from './menuDefs';

function SidebarMenu() {
  const userInfo = useAdminUserInfo();
  const userSort = userInfo?.status as UserSort | undefined;

  // 사용자 권한에 따라 표시할 메뉴 섹션만 필터링
  const visibleSections = useMemo(() => {
    return MENU_SECTIONS.reduce<MenuSectionDef[]>((acc, section) => {
      const visibleItems = section.items.filter((item) =>
        canAccessByPermissions(
          userSort,
          item.requiredPermissions ?? section.requiredPermissions,
        ),
      );
      if (visibleItems.length > 0) {
        acc.push({ ...section, items: visibleItems });
      }
      return acc;
    }, []);
  }, [userSort]);

  return (
    <div className='flex flex-col overscroll-none'>
      <Accordion
        itemClasses={{
          trigger: 'py-4',
          title: 'text-medium font-bold',
        }}
      >
        {visibleSections.map((section) => (
          <AccordionItem
            key={section.id}
            aria-label={section.title}
            title={section.title}
          >
            <Card>
              {section.items.map((item) => (
                <Button
                  key={item.href}
                  color='primary'
                  variant='light'
                  href={item.href}
                  as={Link}
                >
                  {item.label}
                </Button>
              ))}
            </Card>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}

export default function SideBar() {
  const storage = generateStorage();
  const devMode = storage.get('devMode') === 'true';
  return (
    <div className='sticky left-0 top-0 h-screen w-auto'>
      <aside className='bg-content3 z-50 flex h-full w-48 flex-col gap-4 p-4 shadow-xl'>
        <div className='flex justify-center'>
          <Link
            href='/'
            className='flex flex-col'
          >
            <p className='text-base font-bold'>Simppl Admin</p>
            <p className='text-sm'>{devMode ? 'devMode' : 'prodMode'}</p>
          </Link>
        </div>
        <div className='flex-grow overflow-y-auto'>
          <SidebarMenu />
        </div>
        <Button
          color='danger'
          className='flex-shrink-0'
          onPress={() => postUsersLogout()}
        >
          로그아웃
        </Button>
      </aside>
    </div>
  );
}
